import gql from "graphql-tag";

export const managerQuery = gql`
  query manager($id: ID!) {
    manager(id: $id) {
      name
      email
      phone
      isActive
      regions {
        id
        name
      }
      image {
        id
        name
        link
      }
      accessGroup {
        id
        name
      }
      storage {
        id
        name
      }
    }
  }
`;

export const accessGroupsAndStoragesQuery = gql`
  query accessGroupsAndStorages {
    accessGroups {
      id
      name
    }
    storages {
      id
      name
    }
  }
`;
